export default "__VITE_ASSET__DJApeZKy__";